import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {PermissionType} from "@shared/model";
import {PermissionHelperService} from "@shared/service/permission-helper.service";

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective {
  hasView: boolean = false;

  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly permissionHelper: PermissionHelperService
  ) {
  }

  @Input()
  set hasPermission(permissionSet: { entity: string, verb?: PermissionType }) {
    const authorized = this.permissionHelper.hasPermission(
      permissionSet.entity,
      permissionSet.verb || 'read'
    );

    if (authorized && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!authorized && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
